import { Radar } from "react-chartjs-2";
import { useLocation } from "react-router-dom";
import "../../assets/css/result.css";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthApisUser } from "../../api/userapi/userauth";
import { sessionUser } from "../../utils/storageHelper";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function Result() {
  const location = useLocation();
  const data = location.state?.resultData || []; // get submitted data
  const navigate = useNavigate();
  const pdfRef = useRef(null);
  const page1Ref = useRef(null);
  // const radarRef = useRef(null);
  const user = sessionUser();
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const now = new Date();
  const formattedDate = now.toLocaleDateString();
  const formattedTime = now.toLocaleTimeString();

  const dateText = ` ${formattedDate}`;
  const timeText = ` ${formattedTime}`;

  // Edit Assessment function
  const EditAssessmet = () => {
    navigate("/user/question-page", {
      state: {
        edit: true,
        answers: location.state?.rawAnswers, // 👈 pass untouched
        targets: location.state?.rawTargets,
      },
    });
  };

  // pdf making function
  // const DownloadPdf = async () => {
  //   setIsGenerating(true);

  //   // ✅ Get user email from session helper
  //   const user = sessionUser();
  //   const email = user?.email;
  //   const company = user?.company_name;

  //   if (!email) {
  //     setIsGenerating(false);
  //     toast.error("User email not found in session. Please log in again.");
  //     return;
  //   }

  //   try {
  //     // Hide UI before capturing
  //     if (pdfRef.current) pdfRef.current.classList.add("no-buttons");

  //     const canvas = await html2canvas(pdfRef.current, { scale: 2 });

  //     // Restore visibility
  //     if (pdfRef.current) pdfRef.current.classList.remove("no-buttons");

  //     const imgData = canvas.toDataURL("image/png");

  //     // Calculate approximate base64 image size in MB
  //     // const base64Length = imgData.length - 'data:image/png;base64,'.length;
  //     // const sizeInBytes = 4 * Math.ceil(base64Length / 3) * 0.5624896334383812;
  //     // console.log("🖼️ Image size:", (sizeInBytes / 1024 / 1024).toFixed(2), "MB");

  //     // ✅ Create PDF
  //     const pdf = new jsPDF("p", "pt", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const margin = 30;
  //     const pdfWidth = pageWidth - margin * 2;
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     let heightLeft = pdfHeight;
  //     // let position = margin;
  //     let position = 70;

  //     // FIRST PAGE HEADER
  //     pdf.setFontSize(12);
  //     pdf.text(company, 30, 30);
  //     pdf.setFontSize(10);
  //     pdf.text(email, 30, 50);
  //     // RIGHT SIDE → Date & time
  //     pdf.text(formattedDate, pageWidth - 30, 30, { align: "right" });

  //     pdf.addImage(imgData, "PNG", margin, position, pdfWidth, pdfHeight);
  //     heightLeft -= pageHeight - margin;

  //     while (heightLeft > 0) {
  //       position = heightLeft - pdfHeight + margin;
  //       pdf.addPage();
  //       // HEADER ON NEXT PAGES
  //       pdf.setFontSize(12);
  //       pdf.text(company, 30, 30);
  //       pdf.setFontSize(10);
  //       pdf.text(email, 30, 50);
  //       // RIGHT SIDE → Date & time
  //       pdf.text(formattedDate, pageWidth - 30, 30, { align: "right" });
  //       pdf.addImage(imgData, "PNG", margin, position, pdfWidth, pdfHeight);
  //       heightLeft -= pageHeight - margin;
  //     }

  //     // ✅ Convert to Blob
  //     const blob = pdf.output("blob");

  //     // (Optional) also download locally
  //     pdf.save("result.pdf");

  //     // ✅ Build FormData payload
  //     const form = new FormData();
  //     form.append("email", email);
  //     form.append("pdf", blob, "result.pdf");

  //     // If you want to include extra info:
  //     // form.append("user_id", user.id);

  //     // ✅ Send to backend
  //     setIsSending(true);
  //     for (let [key, value] of form.entries()) {
  //     }

  //     const response = await AuthApisUser.EmailResult(form);

  //     if (response?.data?.success) {
  //       toast.success("PDF sent successfully to your email!");
  //     } else {
  //       toast.success("PDF uploaded successfully!");
  //     }
  //   } catch (err) {
  //     console.error("Error generating or sending PDF:", err);
  //     toast.error("Something went wrong while generating the PDF.");
  //   } finally {
  //     setIsGenerating(false);
  //     setIsSending(false);
  //   }
  // };

  // new pdf making

  const DownloadPdf = async () => {
    setIsGenerating(true);
    setIsSending(false);

    try {
      const user = sessionUser();
      const email = user?.email;
      const company = user?.company_name;

      if (!email || !company) {
        toast.error("User session invalid. Please log in again.");
        return;
      }

      if (!page1Ref.current) {
        toast.error("PDF sections missing.");
        return;
      }

      pdfRef.current.classList.add("no-buttons");
      // debugger;
      // --- CAPTURE PAGE 1 ---
      const page1Canvas = await html2canvas(page1Ref.current, {
        scale: 1.5,
        useCORS: true,
      });
      const page1Img = page1Canvas.toDataURL("image/jpeg", 0.9);

      // --- CAPTURE PAGE 2 (Radar) ---
      // const radarCanvas = await html2canvas(radarRef.current, {
      //   scale: 1.5,
      //   useCORS: true,
      // });
      // const radarImg = radarCanvas.toDataURL("image/jpeg", 0.9);

      pdfRef.current.classList.remove("no-buttons");

      // --- CREATE PDF ---
      const pdf = new jsPDF("p", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 20;
      const pdfWidth = pageWidth - margin * 2;

      const now = new Date();
      const formattedDate =
        now.toLocaleDateString() + " " + now.toLocaleTimeString();

      // ----------------------------------------
      // ⭐ FUNCTION: Add header on each page
      // ----------------------------------------
      const addHeader = () => {
        // set the color

        pdf.setFontSize(11);
        // Draw label
        pdf.setTextColor("#7c8c27");
        pdf.setFont("helvetica", "bold");
        pdf.text("Company Name: ", 30, 30);

        // Draw value (colored)
        pdf.setTextColor("#85a126");
        pdf.setFont("helvetica", "nornal");
        pdf.text(company, 120, 30); // shift X so it appears after label

        pdf.setTextColor("#7c8c27");
        pdf.setFont("helvetica", "bold");
        pdf.text("Date: ", 30, 50);

        // Draw value (colored)
        pdf.setTextColor("#85a126");
        pdf.setFont("helvetica", "nornal");
        pdf.text(dateText, 60, 50); // shift X so it appears after label
        pdf.setTextColor("#7c8c27");
        pdf.setFont("helvetica", "bold");
        pdf.text("Time: ", 30, 70);

        // Draw value (colored)
        pdf.setTextColor("#85a126");
        pdf.setFont("helvetica", "nornal");
        pdf.text(timeText, 60, 70); // shift X so it appears after label
      };

      // ----------------------------------------
      // ⭐ FUNCTION: Add sliced multi-page image
      // ----------------------------------------
      const addSlicedImage = (img) => {
        const props = pdf.getImageProperties(img);
        const imgHeight = (props.height * pdfWidth) / props.width;

        let remainingHeight = imgHeight;
        let yOffset = 90;

        pdf.addImage(img, "JPEG", margin, yOffset, pdfWidth, imgHeight);
        remainingHeight -= pageHeight - 120;

        while (remainingHeight > 0) {
          pdf.addPage();
          addHeader();

          const offset = (imgHeight - remainingHeight) * -1 + 90;
          pdf.addImage(img, "JPEG", margin, offset, pdfWidth, imgHeight);

          remainingHeight -= pageHeight - 120;
        }
      };

      // ----------------------------------------
      // ⭐ PAGE 1 (Assessment + Bars with slicing)
      // ----------------------------------------
      addHeader();
      addSlicedImage(page1Img);

      // ----------------------------------------
      // ⭐ PAGE 2 (Radar Chart with slicing)
      // ----------------------------------------
      // pdf.addPage();
      // addHeader();
      // addSlicedImage(radarImg);

      // ----------------------------------------
      // EXPORT
      // ----------------------------------------
      const blob = pdf.output("blob");
      // pdf.save("result.pdf");

      const form = new FormData();
      form.append("email", email);
      form.append("pdf", blob, "result.pdf");

      setIsSending(true);
      const response = await AuthApisUser.EmailResult(form);

      if (response?.data?.success) {
        toast.success("PDF sent successfully to your email!");
      } else {
        toast.success("PDF send successfully!");
      }
    } catch (err) {
      console.error("Error generating or sending PDF:", err);
      toast.error("Something went wrong while generating the PDF.");
    } finally {
      setIsGenerating(false);
      setIsSending(false);
    }
  };

  // ✅ Calculate totals so the bigger dataset stays behind
  // const totalScore = data.reduce((sum, d) => sum + d.user_avg, 0);
  // const totalTarget = data.reduce((sum, d) => sum + d.target_avg, 0);

  // const scoreOrder = totalScore < totalTarget ? 1 : 2;
  // const targetOrder = totalTarget < totalScore ? 1 : 2;

  const radarData = {
    labels: data.map((d) => d.metric),
    datasets: [
      {
        label: "Target",
        data: data.map((d) => d.target_avg),
        backgroundColor: "#725581", // ✅ lower opacity
        borderColor: "#725581",
        borderWidth: 2,
        pointRadius: 0,
        fill: true,
        order: 2, // ✅ dynamic ordering
      },
      {
        label: "Score",
        data: data.map((d) => d.user_avg),
        backgroundColor: "rgba(124, 140, 39, 1)", // ✅ lower opacity
        borderColor: "rgba(124, 140, 39, 1)",
        borderWidth: 2,
        pointRadius: 0,
        fill: true,
        order: 1, // ✅ dynamic ordering
      },
    ],
  };

  // Get highest value from both arrays
  const allValues = [
    ...data.map((d) => d.user_avg),
    ...data.map((d) => d.target_avg),
  ];
  const highestScore = Math.max(...allValues);

  const radarMax = 4; // 👈 change this!
  // Round up to the nearest integer for nicer grid lines
  // radarMax = Math.ceil(highestScore);

  // ✅ Track window width to update chart font size responsively
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Dynamically adjust font size & padding for mobile
  const labelFontSize = isMobile ? 8 : 21;
  const labelPadding = isMobile ? 6 : 15;
  const maxCharsPerLine = isMobile ? 20 : 32;

  // const radarOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false, // ✅ allow responsive resizing
  //   /* aspectRatio: 1/1, // ✅ keep it square */
  //   plugins: {
  //     legend: { display: false },
  //     tooltip: { enabled: true },
  //   },
  //   //       elements: {
  //   //   line: {
  //   //     borderJoinStyle: "round",
  //   //     tension: 0.4, // makes the dataset curves smooth/circular
  //   //   },
  //   //   point: {
  //   //     radius: 0,
  //   //   },
  //   // },
  //   scales: {
  //     r: {
  //       min: 0,
  //       max: radarMax,
  //       ticks: {
  //         display: false,
  //         stepSize: radarMax / 4, // ✅ exactly 4 spider web lines
  //       },
  //       grid: { color: "#e6e5e5ff", z: 2, circular: true },
  //       angleLines: { color: "#e6e5e5ff", z: 2, circular: true },
  //       pointLabels: {
  //         color: "#000",
  //         font: { size: labelFontSize, weight: "300", family: "Roboto" },
  //         padding: labelPadding,
  //         // ✅ Better label wrapping
  //         callback: (value) => {
  //           const words = value.split(" ");
  //           let lines = [];
  //           let current = "";

  //           words.forEach((word) => {
  //             if ((current + word).length > maxCharsPerLine) {
  //               lines.push(current.trim());
  //               current = word + " ";
  //             } else {
  //               current += word + " ";
  //             }
  //           });
  //           lines.push(current.trim());
  //           return lines;
  //         },
  //       },
  //     },
  //   },
  // };

  const radarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      r: {
        min: 0,
        max: radarMax,
        ticks: {
          display: false,
          stepSize: radarMax / 4,
        },
        grid: { color: "#e6e5e5ff", z: 2, circular: true },
        angleLines: { color: "#e6e5e5ff", z: 2, circular: true },
        pointLabels: {
          color: "#000",
          font: { size: labelFontSize, weight: "300", family: "Roboto" },
          padding: labelPadding,
          callback: (value) => {
            const words = value.split(" ");
            let lines = [];
            let current = "";
            words.forEach((word) => {
              if ((current + word).length > maxCharsPerLine) {
                lines.push(current.trim());
                current = word + " ";
              } else {
                current += word + " ";
              }
            });
            lines.push(current.trim());
            return lines;
          },
        },
      },
    },
  };

  /*  const radarOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false }, tooltip: { enabled: true } },
  scales: {
    r: {
      min: 0,
      max: radarMax, // use calculated max here
      ticks: { display: false },
      grid: { color: "#c0bcbcff", z: 2 },
      angleLines: { color: "#ece3e3ff", z: 2 },
      pointLabels: {
        color: "#000000ff",
        font: { size: 18, weight: "300", family: "Roboto" },
        padding: 20,
        callback: (value) => {
          const chunkSize = 45;
          const regex = new RegExp(`.{1,${chunkSize}}`, "g");
          return value.match(regex);
        },
      },
    },
  },
};  */

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="result-container">
        <button className="back-link-res" onClick={() => EditAssessmet()}>
          &lt; Back
        </button>
        <div ref={pdfRef} style={{ width: "100%" }}>
          {/* PAGE 1 SECTION */}
          <div ref={page1Ref}>
            <h2 className="result-title fs-sm-4">Assessment Results</h2>

            <div className="result-content">
              {/* Table */}
              <div className="result-table ">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th className="scorecolor">Score</th>
                      <th className="targetcolor">Target</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row) => (
                      <tr key={row.metric_id}>
                        <td>{row.metric}</td>
                        <td className="scorecolor">
                          {Number(row.user_avg).toFixed(1)}
                        </td>
                        <td className="targetcolor">
                          {Number(row.target_avg).toFixed(1)}
                        </td>
                        <td>
                          <div
                            className="bar-wrapper"
                            style={{ width: "100%" }}
                          >
                            <div className="score-wrapper">
                              {[0, 1, 2, 3].map((i) => {
                                const fill = Math.min(
                                  Math.max(row.user_avg - i, 0),
                                  1
                                ); // 0 to 1 range
                                return (
                                  <div className="score-segment" key={i}>
                                    <div
                                      className="score-fill"
                                      style={{ width: `${fill * 100}%` }}
                                    ></div>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="target-wrapper">
                              {[0, 1, 2, 3].map((i) => {
                                const fill = Math.min(
                                  Math.max(row.target_avg - i, 0),
                                  1
                                ); // 0 to 1 range
                                return (
                                  <div className="target-segment" key={i}>
                                    <div
                                      className="target-fill"
                                      style={{ width: `${fill * 100}%` }}
                                    ></div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* PAGE 2 SECTION */}
            {/* <div ref={radarRef}> */}
            {/* Radar Chart */}
            <div className="radar-container">
              <div className="radar-wrapper">
                <Radar data={radarData} options={radarOptions} />
              </div>
            </div>
            {/* </div> */}
            <div className="action-buttons">
              <div className="edit-prime1">
                <button
                  className="btn edit1 btnr"
                  onClick={() => EditAssessmet()}
                >
                  Edit Assessment
                </button>
                <button
                  className="btn primary btnr"
                  onClick={() => DownloadPdf()}
                  disabled={isGenerating || isSending}
                >
                  {isGenerating || isSending ? "Generating..." : "Email PDF"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    //new way to show pdf

    // <div className="d-flex justify-content-center align-items-center min-vh-100">
    //   <div className="result-container">
    //     <button className="back-link-res" onClick={() => EditAssessmet()}>
    //       &lt; Back
    //     </button>

    //     <div ref={pdfRef}>
    //       {/* PAGE 1 SECTION */}
    //       <div ref={page1Ref}>
    //         <h2 className="result-title fs-sm-4">Assessment Results</h2>

    //         <div className="result-content">
    //           {/* Table */}
    //           <div className="result-table ">
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th></th>
    //                   <th className="scorecolor">Score</th>
    //                   <th className="targetcolor">Target</th>
    //                   <th></th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {data.map((row) => (
    //                   <tr key={row.metric_id}>
    //                     <td>{row.metric}</td>
    //                     <td className="scorecolor">{row.user_avg}</td>
    //                     <td className="targetcolor">{row.target_avg}</td>
    //                     <td>
    //                       <div className="bar-wrapper ">
    //                         <div
    //                           className="bar-score border border-dark"
    //                           style={{ width: `${row.user_avg * 80}px` }}
    //                         />
    //                         <div
    //                           className=" border border-dark"
    //                           style={{ width: `${4 * 80}px` }}
    //                         >
    //                           <div
    //                             className="bar-target border border-dark"
    //                             style={{ width: `${row.target_avg * 80}px` }}
    //                           />
    //                         </div>
    //                       </div>
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    //         </div>
    //       </div>

    //       {/* PAGE 2 SECTION — MUST BE OUTSIDE page1Ref */}
    //       <div ref={radarRef} style={{ marginTop: "40px" }}>
    //         <div className="radar-container">
    //           <div className="radar-wrapper">
    //             <Radar data={radarData} options={radarOptions} />
    //           </div>
    //         </div>
    //       </div>

    //       {/* BUTTON SECTION (not included in PDF) */}
    //       <div className="action-buttons">
    //         <div className="edit-prime1">
    //           <button
    //             className="btn edit1 btnr"
    //             onClick={() => EditAssessmet()}
    //           >
    //             Edit Assessment
    //           </button>
    //           <button
    //             className="btn primary btnr"
    //             onClick={() => DownloadPdf()}
    //             disabled={isGenerating || isSending}
    //           >
    //             {isGenerating || isSending ? "Generating..." : "Email PDF"}
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}
